// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5006fdc6] .app-container .el-form-item__label {\n  display: none;\n}\n[data-v-5006fdc6] .innerOrderNo .el-input-group__append {\n  background: #082dc3;\n  color: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
